import React, { useState } from 'react';
import skillsData from './SkillsData';
import './Skills.css';

const Skills = () => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div style={{ position: 'relative', zIndex: 10 }}>
            <div className="skills-container animate-once">
                <h1 className="skills-heading text-center">Skills</h1>
                <div className="skills-grid">
                    {skillsData.map((data) => (
                        <div className="skills" key={data.id}>
                            <img className="transparent-background" width={80} src={data.image} alt={data.technology} />
                            <h3>{data.technology}</h3>
                        </div>
                    ))}
                </div>
            </div>

            <div className='accordion-container'>
                <div className="accordion">
                    <div className="accordion-header" onClick={toggleAccordion}>
                        <h2 className="accordion-title">Additional Skills</h2>
                        <span className={`accordion-icon ${isOpen ? 'open' : 'closed'}`}></span>
                    </div>
                    <div className={`accordion-content ${isOpen ? 'open' : 'closed'}`}>
                        <ul>
                            <li>Typing 80+ WPM</li>
                            <li>English (Proficient)</li>
                            <li>Responsive Web Design</li>
                            <li>Command Line Interface</li>
                            <li>Communication</li>
                            <li>Teamwork</li>
                            <li>Problem-solving</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
